<ng-container [ngSwitch]="dataType">
  <ng-template [ngSwitchCase]="'string'">
    <input
      [name]="element.name"
      [attr.id]="element.name"
      type="text"
      class="form-control form-control-sm"
      [(ngModel)]="defValue"
      (blur)="util.flushDebounce(debounceDefValChanges)"
      (input)="debounceDefValChanges($event)"
      [disabled]="disableField"
    />
  </ng-template>
  <ng-template [ngSwitchCase]="['number'].includes(dataType) ? dataType : null">
    <p-inputNumber
      [(ngModel)]="defValue"
      class="form-control form-control-sm"
      [attr.id]="element.name"
      (onInput)="defNumChanges($event)"
      (onBlur)="util.flushDebounce(debounceValChanges)"
      maxlength="16"
      [disabled]="disableField"
    ></p-inputNumber>
  </ng-template>
  <ng-template [ngSwitchCase]="['currency', 'double'].includes(dataType) ? dataType : null">
    <p-inputNumber
      [(ngModel)]="defValue"
      class="form-control form-control-sm"
      [disabled]="disableField"
      mode="decimal"
      [attr.id]="element.name"
      (onInput)="defNumChanges($event)"
      (onBlur)="util.flushDebounce(debounceValChanges)"
      maxlength="16"
      [minFractionDigits]="formData.f_minFrac"
      [maxFractionDigits]="formData.f_maxFrac"
    ></p-inputNumber>
  </ng-template>
  <ng-template [ngSwitchCase]="['checkbox', 'boolean'].includes(dataType) ? dataType : null">
    <p-checkbox
      [binary]="true"
      [inputId]="element.name"
      [name]="element.name"
      [(ngModel)]="defValue"
      (onChange)="defValChanges($event)"
      [disabled]="disableField"
    ></p-checkbox>
  </ng-template>
  <ng-template [ngSwitchCase]="'text'">
    <textarea
      pTextarea
      [(ngModel)]="defValue"
      [attr.id]="element.name"
      class="form-control form-control-sm"
      [rows]="1"
      autoResize="autoResize"
      (input)="debounceDefValChanges($event)"
      (blur)="util.flushDebounce(debounceDefValChanges)"
      [disabled]="disableField"
    ></textarea>
  </ng-template>
  <ng-template [ngSwitchCase]="['dropdown', 'radio'].includes(dataType) ? dataType : null">
    <div *ngIf="!formData.f_hasMultiVal">
      <vb-dynamic-dropdown
        [options]="dynamicOptions"
        [element]="element"
        [(ngModel)]="defValue"
        [disableField]="disableField"
        [ngModelOptions]="{ standalone: true, updateOn: 'change' }"
        (valChanges)="defValChanges($event)"
      >
      </vb-dynamic-dropdown>
    </div>
    <div *ngIf="formData.f_hasMultiVal">
      <p-multiselect
        resetFilterOnHide="true"
        [options]="dynamicOptions"
        optionLabel="label"
        optionValue="value"
        [(ngModel)]="defValue"
        appendTo="body"
        (onPanelHide)="defValChanges($event)"
        [[disabled]="disableField"
      >
      </p-multiselect>
    </div>
  </ng-template>
  <ng-template [ngSwitchCase]="'checkboxgroup'">
    <p-multiselect
      resetFilterOnHide="true"
      [options]="dynamicOptions"
      optionLabel="label"
      optionValue="value"
      [(ngModel)]="defValue"
      appendTo="body"
      (onPanelHide)="defValChanges($event)"
      [disabled]="disableField"
    >
    </p-multiselect>
  </ng-template>
  <ng-template [ngSwitchCase]="'date'">
    <p-select
      [options]="dateOptions"
      [(ngModel)]="dateVal"
      placeholder="Select"
      appendTo="body"
      [disabled]="disableField"
      [showClear]="true"
      (onChange)="onDateOptChange($event)"
      optionLabel="label"
      optionValue="value"
    >
    </p-select>
  </ng-template>
  <ng-template [ngSwitchCase]="'datetime'">
    <p-select
      [options]="dateOptions"
      [(ngModel)]="dateVal"
      placeholder="Select"
      [disabled]="disableField"
      [showClear]="true"
      appendTo="body"
      (onChange)="onDateOptChange($event)"
      optionLabel="label"
      optionValue="value"
    >
    </p-select>
  </ng-template>
  <ng-template [ngSwitchCase]="'yes no'">
    <p-select
      [showClear]="true"
      [options]="ynOptions"
      [(ngModel)]="defValue"
      optionLabel="name"
      placeholder="Select"
      [disabled]="disableField"
      optionValue="value"
      (onChange)="defValChanges($event)"
    >
    </p-select>
  </ng-template>
  <ng-template [ngSwitchCase]="'email'">
    <input
      [name]="element.name"
      [attr.id]="element.name"
      type="text"
      class="form-control form-control-sm"
      [disabled]="disableField"
      [(ngModel)]="defValue"
      (focusout)="defValChanges($event)"
    />
  </ng-template>
  <ng-template [ngSwitchCase]="'url'">
    <input
      [name]="element.name"
      [attr.id]="element.name"
      type="url"
      class="form-control form-control-sm"
      [disabled]="disableField"
      [(ngModel)]="defValue"
      (focusout)="defValChanges($event)"
    />
  </ng-template>
</ng-container>
